import React from 'react'

import { LeftImageContent, NoImageContent, RightImageContent } from '..'
import { SectionProps } from '../../../../core/types/Help'
import { List, SectionTitle, Text } from '../ContentItem'
import { HELP_IMAGES } from '../../../constants/HelpImages'
import { buildDynamicCopy } from '../../../../core/utils/Localization'

const Budget: React.FC<SectionProps> = ({ copy, topicKey }) => {
  const copyContent = copy.budgets_overview

  const BudgetTopicContent: { [key: string]: React.JSX.Element } = {
    'budgets-overview': (
      <React.Fragment>
        <RightImageContent
          altImage={copyContent.overview_alt_image}
          content={
            <React.Fragment>
              <Text content={copyContent.overview_description} sx={{ mt: 24 }} />
              <Text content={copyContent.overview_list_description} sx={{ mt: 12 }} />
              <List
                items={[
                  buildDynamicCopy(
                    copyContent.overview_list_item_1_text,
                    <b>{copyContent.overview_list_item_1_bold}</b>,
                  ) as React.ReactNode,
                  buildDynamicCopy(
                    copyContent.overview_list_item_2_text,
                    <b>{copyContent.overview_list_item_2_bold}</b>,
                  ) as React.ReactNode,
                ]}
              />
            </React.Fragment>
          }
          image={HELP_IMAGES.BUDGETS_WIDGET}
        />
        <SectionTitle content={copyContent.adjusting_income_title} sx={{ pt: 48 }} />
        <LeftImageContent
          altImage={copyContent.adjusting_income_alt_image}
          content={
            <React.Fragment>
              <Text content={copyContent.adjusting_income_list_description} sx={{ mt: 24 }} />
              <List
                items={[
                  buildDynamicCopy(
                    copyContent.adjusting_income_list_items_1_text,
                    <b>{copyContent.adjusting_income_list_items_1_bold}</b>,
                  ) as React.ReactNode,
                  buildDynamicCopy(
                    copyContent.adjusting_income_list_items_2_text,
                    <b>{copyContent.adjusting_income_list_items_2_bold}</b>,
                  ) as React.ReactNode,
                ]}
                listType="ol"
              />
            </React.Fragment>
          }
          image={HELP_IMAGES.BUDGETS_EDIT_INCOME}
        />
        <SectionTitle content={copyContent.create_budget_title} sx={{ pt: 48 }} />
        <RightImageContent
          altImage={copyContent.create_budget_alt_image}
          content={
            <React.Fragment>
              <List
                items={[
                  copyContent.create_budget_list_items_1,
                  copyContent.create_budget_list_items_2,
                  buildDynamicCopy(
                    copyContent.create_budget_list_items_3,
                    <b>{copyContent.create_budget_list_items_3_bold_1}</b>,
                    <b>{copyContent.create_budget_list_items_3_bold_2}</b>,
                    <b>{copyContent.create_budget_list_items_3_bold_1}</b>,
                  ) as React.ReactNode,
                ]}
              />
            </React.Fragment>
          }
          hasDivider={false}
          image={HELP_IMAGES.BUDGETS_ADD_SUB_BUDGET}
        />
        <NoImageContent
          content={<Text content={copyContent.see_transactions_description} />}
          hasDivider={false}
        />
      </React.Fragment>
    ),
  }
  return BudgetTopicContent[topicKey]
}

export default Budget
